import { render, staticRenderFns } from "./signinglist.vue?vue&type=template&id=627c032c&scoped=true&"
import script from "./signinglist.vue?vue&type=script&lang=js&"
export * from "./signinglist.vue?vue&type=script&lang=js&"
import style0 from "./signinglist.vue?vue&type=style&index=0&id=627c032c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c032c",
  null
  
)

export default component.exports